/* This file is autogenerated, see readme.md for instructions */
import RenameAltSvgIcon from '@bloomreach/banana-theme/icons/rename-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RenameAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RenameAltSvgIcon />
    </Icon>
  );
});

RenameAltIcon.displayName = 'RenameAltIcon';

export default RenameAltIcon;
